/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { chatCancelToolCall } from '../../axios/chatCancelToolCall'
import type {
	ChatCancelToolCallError,
	ChatCancelToolCallPathParams,
	ChatCancelToolCallResponse,
} from '../../types/ChatCancelToolCall'

export const chatCancelToolCallMutationKey = () => [{ url: '/chat/:chat/tool-calls/:toolCallId/cancel' }] as const

export type ChatCancelToolCallMutationKey = ReturnType<typeof chatCancelToolCallMutationKey>

export type ChatCancelToolCallVariables = {
	chat: ChatCancelToolCallPathParams['chat']
	toolCallId: ChatCancelToolCallPathParams['toolCallId']
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::cancelToolCall */
export function useChatCancelToolCall<TContext = unknown>(
	options?: UseMutationOptions<
		ChatCancelToolCallResponse,
		AxiosError<ChatCancelToolCallError>,
		ChatCancelToolCallVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: chatCancelToolCallMutationKey(),
		mutationFn: ({ chat, toolCallId }: ChatCancelToolCallVariables) =>
			chatCancelToolCall(chat, toolCallId, config).then(res => res.data),
		...options,
	})
}
